import { useState } from 'react'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import notify from 'components/atoms/Notify'
import apiPost from 'lib/network/apiPost'
import moment from 'moment-timezone'

const GeneratePartnerKeyModal = ({ onSuccess, close, partnerId }) => {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({
    expiryDate: '',
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const keySchema = Yup.object().shape({
    expiryDate: Yup.date().min(new Date(), t('generatePartnerKeyModal.validation.expiryDateMustBeFuture')).required(t('generatePartnerKeyModal.validation.expiryDateRequired')),
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: '' }))
  }

  const handleGenerateKey = async () => {
    try {
      setLoading(true)
      await keySchema.validate(formData, { abortEarly: false })

      const payload = {
        expiryDate: moment(formData.expiryDate).toISOString(),
      }

      const response = await apiPost(`partner-key/${partnerId}`, payload)
      if (response.success) {
        notify.success(t('generatePartnerKeyModal.messages.keyGeneratedSuccessfully'))
        onSuccess(response.data)
      } else {
        notify.error(response.message || t('generatePartnerKeyModal.messages.failedToGenerateKey'))
      }
    } catch (validationError) {
      if (validationError.inner) {
        const newErrors = {}
        // eslint-disable-next-line
        validationError.inner.forEach(err => {
          newErrors[err.path] = err.message
        })
        setErrors(newErrors)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div className="mb-4">
        <label htmlFor="expiryDate" className="block text-sm font-medium text-gray-700 mb-1">
          {t('generatePartnerKeyModal.labels.expiryDate')} *
        </label>
        <input
          type="datetime-local"
          name="expiryDate"
          id="expiryDate"
          value={formData.expiryDate}
          onChange={handleChange}
          min={moment().format('YYYY-MM-DDTHH:mm')}
          className="block w-full rounded-md border-gray-300 shadow-sm sm:text-sm focus:ring-dark-500 focus:border-dark-500"
        />
        {errors.expiryDate && <p className="text-sm text-red-600 mt-1">{errors.expiryDate}</p>}
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          disabled={loading}
          onClick={handleGenerateKey}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
        >
          {loading ? t('generatePartnerKeyModal.buttons.generating') : t('generatePartnerKeyModal.buttons.generateKey')}
        </button>
        <button
          type="button"
          className="ml-2 inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200"
          onClick={close}
          disabled={loading}
        >
          {t('generatePartnerKeyModal.buttons.cancel')}
        </button>
      </div>
    </div>
  )
}

export default GeneratePartnerKeyModal
